export default {
  title: 'Specify the email',
  subtitle:
    'Please enter the email for us to look for other accounts connected to this email',
  placeholder: {
    email: 'Email address',
  },
  button: {
    cancel: 'Cancel',
    next: 'Next',
  },
};
